// extracted by mini-css-extract-plugin
module.exports = {"expanderPanel":"_3AvyBIda","titleContainer":"i4Iohv9H","isOpen":"_2QbLfQfd","content":"Fho69JYE","isDark":"_1sQwcnRu"};